import { ADD_HOMEOSINIATRIA } from "./types";

export default (state = [], action) => {
  switch (action.type) {
    case ADD_HOMEOSINIATRIA:
      return action.payload;
    default:
      return state;
  }
};
